/**
 * Die Einzelheiten der Artwork-Pruefung als nachgeladener Chunk: der Dialog mit der Tabelle der Wunschfolie gehoert nicht ins
 * Eintrittsbuendel (Grenze in `test/reference/bundle.test.ts`), erst das Oeffnen laedt ihn. Wer ihn nur bei Bedarf rendert
 * (`{offen && <ArtworkPruefungEinzelheitenLazy … />}`), zahlt den Abruf erst dann. Verwendet von `Positionsdokumente.tsx`; die
 * Zusammenfassung des Massenuploads (`Massenupload/useArtworkPruefungAbschnitt.tsx`) liegt ohnehin im Lazy-Chunk des Dialogs
 * und importiert das Modul statisch - Rolldown teilt es dann als eigenen Chunk, den beide laden.
 *
 * Gleiche Bauart wie `Drawer/TrennenDialogLazy.tsx`. Die Einzelheiten haengen einen eigenen Escape-Listener (siehe
 * `ArtworkPruefungEinzelheiten.tsx`): solange der Chunk laedt, sperrt `EscapeSperre` den Escape, damit er nicht die Board-Auswahl
 * leert oder den Drawer schliesst.
 *
 * Diese Datei importiert den Fehlerstapel NICHT (Rolldown-Falle, Kopf von `melder.ts`): der Melder kommt wie bisher als Prop.
 *
 * ================= Wenn der Chunk nicht laedt =================
 *
 * Ein alter Tab nach einem Deployment kennt `ArtworkPruefungEinzelheiten-<hash>.js` nicht mehr: `import()` scheitert, `React.lazy`
 * wirft beim Rendern. Ohne Grenze dazwischen faengt das erst die Wurzelgrenze (`FehlerGrenze` in `src/App.tsx`) und ersetzt die GANZE
 * Anwendung durch „Bitte die Seite neu laden“ - vor dem Auslagern konnte das nicht passieren (das Modul lag im Eintritt). Die
 * Einzelheiten sind ein Nebenweg des Reiters Dokumente; Board und Drawer sollen stehen bleiben (ungespeicherte Eingaben der Sitzung
 * gehen sonst verloren). `NachladeGrenze` (`components/NachladeGrenze.tsx`, dieselbe Klasse wie beim Massenupload-Dialog und bei den
 * Zollinstruktionen) meldet den Fehler ueber den uebergebenen Melder (bei einem Chunk-Ladefehler mit `FEHLERTEXTE.neuLaden`, das macht
 * der Uebersetzer `fehlertext` im Fehlerstapel), ruft `onSchliessen` und zeichnet nichts. `React.lazy` merkt sich die Ablehnung: ein
 * zweiter Versuch ohne Neuladen scheitert gleich wieder, die Meldung bleibt dann dieselbe.
 */
import { lazy, Suspense } from "react";
import { NachladeGrenze } from "../../../NachladeGrenze.tsx";
import { EscapeSperre } from "../../TrennenDialogLazy.tsx";
import type { ArtworkPruefungEinzelheitenProps } from "./ArtworkPruefungEinzelheiten.tsx";

const EinzelheitenChunk = lazy(() =>
  import("./ArtworkPruefungEinzelheiten.tsx").then((m) => ({ default: m.ArtworkPruefungEinzelheiten })),
);

// Neutral: die Grenze faengt auch einen Absturz mitten im Zeichnen der Einzelheiten, nicht nur den Chunk-Ladefehler.
const FEHLER_KONTEXT = "Die Einzelheiten der Artwork-Prüfung konnten nicht angezeigt werden.";

export function ArtworkPruefungEinzelheitenLazy(props: ArtworkPruefungEinzelheitenProps) {
  return (
    <NachladeGrenze melde={props.melder.meldeFehler} kontext={FEHLER_KONTEXT} onSchliessen={props.onSchliessen}>
      <Suspense fallback={<EscapeSperre />}>
        <EinzelheitenChunk {...props} />
      </Suspense>
    </NachladeGrenze>
  );
}
